import { z } from 'zod';
export const loginSchema = z.object({ email: z.string().trim().email('Correo inválido'), password: z.string().min(1, 'Escribe tu contraseña') });
export const mfaLoginSchema = z.object({ mfaToken: z.string().min(1), code: z.string().trim().min(6).max(12) });
export const forgotPasswordSchema = z.object({ email: z.string().trim().email() });
export const passwordSchema = z.string().min(10, 'Al menos 10 caracteres').max(200);
export const resetPasswordSchema = z.object({ token: z.string().min(20), password: passwordSchema });
export const changePasswordSchema = z.object({ current: z.string().min(1), password: passwordSchema });
export const mfaCodeSchema = z.object({ code: z.string().trim().min(6).max(12) });
export const preferencesSchema = z.object({
    theme: z.enum(['light', 'dark']).optional(),
    emailNotifications: z.boolean().optional(),
    /** Apps de las que la persona no quiere avisos por correo (sí en la campana). Las apps lo leen por la API de servicio. */
    emailMutedApps: z.array(z.string().regex(/^[a-z][a-z0-9-]{1,30}$/)).max(50).optional(),
});
export const PASSWORD_RESET_TTL_MINUTES = 30;
export const INVITE_TTL_HOURS = 72;
export const MFA_RECOVERY_CODES = 8;
export const IDLE_HEADER = 'x-idle-seconds';
export const SESSION_END_CODES = { IDLE: 'SESSION_IDLE', EXPIRED: 'SESSION_EXPIRED', REVOKED: 'SESSION_REVOKED' };
//# sourceMappingURL=auth.js.map